import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ContextMenuCommandCommand from './contextmenucommand';

export default class ContextMenuEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add( 'contextmenu', new ContextMenuCommandCommand( editor ) );
  }
}
